import { REDUX_SLICE } from '../constants';
import { appSlice } from '../slices/app.slice';

export const reducer = {
  [REDUX_SLICE.APP]: appSlice.reducer,
};
